<template>
  <header id="header" ref="headerRef">
  <div class="hd-inner">
    <h1>
      <a href="#n" @click.prevent="goMain"><img src="../assets/img/img_logo.png" alt="문화셈터" /></a>
    </h1>
    <nav id="gnb" @mouseleave="pcGnbHidden()">
      <ul>
        <li v-for="(topMenRoute, i) in routes" :key="i">
          <a href="javascript:;" @click="clickTopMenu(topMenRoute, $event)" @mouseenter="pcGnb()">{{ topMenRoute.name }}</a>
          <div class="dep3-menu" :class="`dep3-${i+1}`">
            <h2>{{ topMenRoute.name }}</h2>
            <ul>
              <li v-for="(subMenuRoute, j) in topMenRoute.children" :key="j">
                <a href="javascript:;" @click="clickSubMenu(subMenuRoute)">{{ subMenuRoute.name }}
                  <div v-if="subMenuRoute.meta.linkUrl" class="btn-new-window" style="padding: 0px; border: 0px"></div>
                </a>
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </nav>
    <div class="header-option-btn">
      <button type="button" class="header-search-btn" @click="clickShowSearch()">
        <img src="../assets/img/btn_search.png" alt="검색" />
      </button>
      <button type="button" class="all-menu-btn off" @click="allMenu()">
        <span></span>
        <span></span>
        <span></span>
      </button>
    </div>
  </div>
  <div class="gnb-layer"></div>
  <div class="header-search-wrap" ref="headerSearchWrap">
      <div class="main-search-wrap">
        <div class="main-search">
          <label for="findNm" class="ir">검색창</label>
          <input type="search" v-model="findNm" id="findNm" placeholder="통계자료 검색·키워드를 입력해주세요." v-on:keyup.enter="goSearch()">
          <a href="javascript:;" @click="goSearch()" title="검색하기">
            <img src="../assets/img/ico_main_search.png" alt="검색하기">
          </a>
        </div>
        <div class="popular-search-terms align-start">
          <span>인기검색어</span>
          <a href="javascript:;" @click="goSearch(data.srchLang)" v-for="(data, idx) in setKeywordDataList" :key="idx">#{{data.srchLang}}</a>
        </div>
      </div>
    </div>
</header>
</template>

<script>
import EventBus from '../assets/js/eventBus'
import $ from 'jquery'
import * as menuApi from "@/api/Menu";

export default {
	name: 'Header',
	components: {},
	props: {
		isShowFocusMenuType: {
			type: Boolean,
			default: false
		},
		keywordDataList: {
			type: Array,
			default: () => []
		}
	},

	data () {
		return {
			searchImage: '',
			hamburgerImage: '',
			findNm: ''
		}
	},

	computed: {
		routes () {
			const topMenus = []
			for (const topMenu of this.$router.options.routes) {
				if (topMenu.meta.visible && topMenu.meta.visibleMenu !== false) {
					const subMenus = []
					for (const subMenu of topMenu.children) {
						if (subMenu.meta.visible) {
							subMenus.push(subMenu)
						}
					}

					topMenu.children = subMenus
					topMenus.push(topMenu)
				}
			}
			return topMenus
		},

		setKeywordDataList () { // 인기검색어
			let data = this.keywordDataList

			if (this.$store.getters.trendKeywords != '') {
				data = this.$store.getters.trendKeywords[0].items
			}
			return data
		}
	},

	watch: {
		isShowFocusMenuType: function () {
			//this.showMenuStyle(false)
		}
	},

	mounted () {
    const detectMediaSize = () => {
      if (window.matchMedia('(min-width: 0px) and (max-width: 1125px)').matches) {
        document.querySelector('html').classList.add('mobile')
        if (document.querySelector('html').classList.contains('desktop')) {
          document.querySelector('#gnb').removeEventListener('mouseleave', this.pcGnbHide)
          document.querySelector('#gnb').removeEventListener('mouseenter', this.pcGnbShow)
          document.querySelector('html').classList.remove('desktop')
          document.querySelector('#header').classList.remove('active')
          document.querySelector('.all-menu-btn').classList.remove('open')
          document.querySelector('.all-menu-btn').classList.add('off')
          document.querySelector('.gnb-layer').classList.remove('open')
          document.querySelectorAll('.dep3-menu').forEach((item) => {
            item.classList.remove('open')
          })
        }
      } else {
        document.querySelector('html').classList.add('desktop')
        if (document.querySelector('html').classList.contains('mobile')) {
          document.querySelector('html').classList.remove('mobile')
        }
        document.querySelectorAll('.dep3-menu').forEach((item) => {
          item.removeAttribute('style')
        })

        document.querySelectorAll('.dep3-menu').forEach((item) => {
        item.addEventListener('mouseenter', () => {
          item.previousElementSibling.classList.add('active')
        })

        item.addEventListener('mouseleave', () => {
          item.previousElementSibling.classList.remove('active')
        })
      })

        document.querySelector('#header').classList.remove('active')
        document.querySelector('.all-menu-btn').classList.remove('open')
        document.querySelector('.all-menu-btn').classList.add('off')
        document.querySelector('#header').classList.remove('active')
        document.querySelector('#header #gnb > ul > li > a').classList.remove('active')
      }
    }

    window.addEventListener('resize', detectMediaSize, false)
    detectMediaSize()
	},

	destroyed () {},

	methods: {
    allMenu () {
      if (window.matchMedia('(min-width: 0px) and (max-width: 1125px)').matches) {
        this.mobileGnb()
      } else {
        this.pcAllMenu()
      }
    },

    mobileGnb () {
      if (document.querySelector('.all-menu-btn').classList.contains('off')) {
        document.querySelector('#header').classList.add('active')
        document.querySelector('.all-menu-btn').classList.remove('off')
        document.querySelector('.all-menu-btn').classList.add('open')
      } else {
        document.querySelector('#header').classList.remove('active')
        document.querySelector('.all-menu-btn').classList.remove('open')
        document.querySelector('.all-menu-btn').classList.add('off')
      }
    },

    pcGnb() {
      if (window.matchMedia('(min-width: 1126px)').matches) {
        this.pcGnbShow()
      }
    },

    pcGnbHidden() {
      if (window.matchMedia('(min-width: 1126px)').matches) {
        if (document.querySelector('.all-menu-btn').classList.contains('off')) {
          this.pcGnbHide()
        }
      }
    },

    pcAllMenu () {
      if (document.querySelector('.all-menu-btn').classList.contains('off')) {
        this.pcGnbShow()
        document.querySelector('.all-menu-btn').classList.remove('off')
        document.querySelector('.all-menu-btn').classList.add('open')
      } else {
        this.pcGnbHide()
        document.querySelector('.all-menu-btn').classList.remove('open')
        document.querySelector('.all-menu-btn').classList.add('off')
      }
    },

    pcGnbShow () {
      document.querySelectorAll('.dep3-menu').forEach((item) => {
        item.classList.add('open')
      })
      document.querySelector('.gnb-layer').classList.add('open')
    },

    pcGnbHide () {
      document.querySelectorAll('.dep3-menu').forEach((item) => {
        item.classList.remove('open')
      })
      document.querySelector('.gnb-layer').classList.remove('open')
    },

		goMain () {
			this.$router.push({ name: '메인화면' })
		},

    /**
     * TOPMENU 클릭
     * @param route
     * @param event
     */
		clickTopMenu (route, event) {
			this.closeSearch()

			let routePath = ''

			if (route.children) {
				routePath = route.children[0].name

        if (routePath === '문화') {
          this.loadSubMenu('STBL-1014250').then(items => {
            const firstMenu = items.at();
            //INFO 조사 자동 선택
            this.$router.push({ name: routePath, params: { subItemId: firstMenu.mgmNo } })
          });
        } else {
          this.$router.push({ name: routePath })
        }
			}

      if (window.matchMedia('(min-width: 0px) and (max-width: 1125px)').matches) {
        document.querySelectorAll('#gnb > ul > li > a').forEach((item) => {
          item.classList.remove('active')
          item.nextElementSibling.style.display = 'none'
        })
        event.target.classList.add('active')
        event.target.nextElementSibling.style.display = 'block'
        event.preventDefault()
      } else {
        if(document.querySelector('.all-menu-btn').classList.contains('open')) {
            document.querySelector('.all-menu-btn').classList.add('off')
        }
        document.querySelector('.all-menu-btn').classList.remove('open')
        document.querySelector('.all-menu-btn').classList.add('off')
        document.querySelector('.gnb-layer').classList.remove('open')
        document.querySelectorAll('.dep3-menu').forEach((item) => {
          item.classList.remove('open')
        })
      }
		},

		clickSubMenu (route) {
			this.closeSearch()
			let routePath = ''

			if (route) {
				routePath = route.name

				if (route.component) {
					if (route.meta.subMenuItemMgmNo) {

            const upperMgmNo = route.meta.subMenuItemMgmNo;
            this.loadSubMenu(upperMgmNo).then(items => {
              const firstMenu = items.at();
              //INFO 조사 자동 선택
              this.$router.push({ name: routePath, params: { subItemId: firstMenu.mgmNo } })
            });
					} else {
            this.$router.push({ name: routePath })
          }
				} else {
					if (route.meta.linkUrl) {
						window.open(route.meta.linkUrl)
					}
				}
			}

      if (window.matchMedia('(min-width: 0px) and (max-width: 1125px)').matches) {
        document.querySelector('#header').classList.remove('active')
        document.querySelector('.all-menu-btn').classList.remove('open')
        document.querySelector('.all-menu-btn').classList.add('off')
      } else {
        document.querySelector('#header').classList.remove('active')
        if(document.querySelector('.all-menu-btn').classList.contains('open')) {
            document.querySelector('.all-menu-btn').classList.add('off')
        }
        document.querySelector('.all-menu-btn').classList.remove('open')
        document.querySelector('.gnb-layer').classList.remove('open')
        document.querySelectorAll('.dep3-menu').forEach((item) => {
          item.classList.remove('open')
        })

      }
		},

    /**
     * 서브 메뉴 정보 조회
     * @param statId
     * @returns {Promise<unknown>}
     */
    loadSubMenu(statId) {
      return new Promise(resolve => {
        const subMenuItem = this.$store.getters.findSubMenu(statId);
        if (subMenuItem) {
          resolve(subMenuItem.items);
          return;
        }

        menuApi.searchMenuSubItems({type: 'STBL', upMgmNo: statId }).then(result => {
          resolve(result.data);
        });
      })
    },

		clickShowSearch () {
			if (this.$refs.headerSearchWrap.classList.toggle('on')) {
				//$('.depth02').stop().slideUp(300)
			}
		},

		closeSearch () {
			// this.showMenuStyle(false)
			this.$refs.headerSearchWrap.classList.remove('on')
		},

		goSearch (srchLang) {
			let findNm = this.findNm

			if (srchLang != undefined) {
				findNm = srchLang
			}

			const param = {
				searchFindNm: findNm
			}

			this.$router.push({ name: '통합검색', query: param })
			this.$refs.headerSearchWrap.classList.remove('on')
			this.findNm = ''
		}
	}
}
</script>

<style scoped>

</style>
